import React from 'react';
import PropTypes from 'prop-types';

import NormalGeneralTextField from '../../normal/GeneralTextField';

const propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }).isRequired,
  meta: PropTypes.shape({
    error: PropTypes.string,
    touched: PropTypes.bool,
    invalid: PropTypes.bool,
  }).isRequired,
  tooltip: PropTypes.string,
};

const defaultProps = {
  tooltip: '',
};

const GeneralTextField = props => {
  const {
    input: { value, onChange, onBlur, onFocus },
    meta: { error, touched, invalid },
    tooltip,
    ...otherProps
  } = props;

  return (
    <NormalGeneralTextField
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      onFocus={onFocus}
      errMsg={error}
      tooltip={tooltip}
      touched={touched}
      invalid={invalid}
      {...otherProps}
    />
  );
};

GeneralTextField.propTypes = propTypes;
GeneralTextField.defaultProps = defaultProps;

export default GeneralTextField;
